import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';
import { withFirebase } from '../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';
import Popup from "reactjs-popup";
import { EditSoundtrailScreen } from '../EditSoundtrail';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        height: 100,
        width: 300,
        justifyContent: 'left',
    },
    cover: {
        width: 100,
        height: 100,
    },
}));


const SoundtrailCard = (props) => (
    SoundtrailCardWithFirebase(props)
)

const CodeDisplay = props => {
    if (props.code === undefined) {
        return  <div />
    }

    return (
    <div>
        Soundtrail code: 
        <div style={{backgroundColor:"#eeeeee",width:"40px", float:"right"}}>
            {props.code.toUpperCase()}
        </div>
    </div>
    )
}

const PublishDisplay = props => {
    if (props.inApps === undefined || props.inApps.length <= 0) {
        return  <div />
    }

    return (
    <div style={{color:"#ff9800"}}>
        Published in: {props.inApps.toString()}
    </div>
    )
}

const SoundtrailCardBase = props => {
    const classes = useStyles();
    const [redirect, doRedirect] = React.useState(false)
    const [loading, setLoading] = React.useState(1)
    const [imageLink, setImageLink] = React.useState(props.image);
    const { firebase } = props;

    if (!imageLink.includes("http://") && !imageLink.includes("https://") && loading === 1) {
        firebase.getThumbnail(imageLink).then((url) => {
            setImageLink(url);
            setLoading(0)
        })
        setLoading(2) // this is so it doesn't loop multiple times
    } else if (loading === 1) {
        setLoading(0)
    }

    if (loading > 0) {
        return (
            <Card className={classes.root} style={props.style}>
                <CardMedia
                    className={classes.cover}
                >
                    <CircularProgress style={{ margin: "25px" }} />
                </CardMedia>
                <CardContent>
                    <Typography variant="h5" component="h2">
                        {props.name}
                    </Typography>
                </CardContent>
            </Card>
        )
    }

    const prop = {
        stxUrl: props.stxUrl,
        open: props.open,
        name: props.name,
        image: props.image,
        id: props.id,
        inApps: props.inApps,
        onClose: () => doRedirect(false)
    }


    return (
        <Card className={classes.root} style={props.style}>
            <Popup
                open={redirect}
                modal
                onClose={() => doRedirect(false)}
                closeOnDocumentClick={false}
                contentStyle={{ border: "none", width: "0px", padding: "0px" }}
            >
                <EditSoundtrailScreen {...prop} />
            </Popup>

            <CardActionArea className={classes.root} onClick={() => { doRedirect(true) }}>
                <CardMedia
                    image={imageLink} // crop to square
                    className={classes.cover}
                />
                <CardContent>
                    <Typography variant="h5" component="h2">
                        {props.name}
                        <br />
                    </Typography>
                    <CodeDisplay code={props.code} />
                    <PublishDisplay inApps={props.inApps} />
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

const SoundtrailCardWithFirebase = withFirebase(SoundtrailCardBase);

export default SoundtrailCard;